<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <el-form-item label="群组名称" prop="groupAppellation">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.groupAppellation"
          placeholder="请输入群组名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="关联信息" prop="relType">
        <el-radio-group
          size="small"
          placeholder="请选择关联信息"
          v-model="ruleForm.relType"
          @change="switchRelType"
        >
          <el-radio label="membercard">会员卡</el-radio>
          <el-radio label="memberlabel">会员标签</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="关联内容" prop="relIdLabel">
        <el-select
          size="small"
          clearable
          placeholder="请选择关联内容"
          v-model="ruleForm.relIdCardValue"
          v-show="ruleForm.relType == 'membercard'"
          filterable
        >
          <el-option
            :label="v.typeName"
            :value="v.cardTypeId"
            v-for="(v, i) in vipCardTypeList.records"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="请选择关联内容"
          v-show="ruleForm.relType == 'memberlabel'"
          v-model="ruleForm.relIdLabelValue"
          filterable
          multiple
        >
          <el-option
            :label="v.labelName"
            :value="v.labelId"
            v-for="(v, i) in alllabelSystemList.records"
            :key="i"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份背景图" prop="groupBackgroundImg">
        <my-upload
          field="file"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'goodsCenter' }"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="show"
          noCircle
          noSquare
          :width="750"
          :height="360"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!listHeaderImgUrl"
          @click="toggleShow"
          >点击上传</el-button
        >
        <span class="form-tip"
          >只能上传jpg/png文件，且不能超过1MB，建议图片尺寸为750x360像素的png图(最多上传一张）</span
        >
        <div class="priview" v-if="listHeaderImgUrl">
          <img :src="listHeaderImgUrl" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="专属权益" prop="profitValue">
        <div>
          商品折扣
          <el-input
            type="number"
            style="width:130px"
            size="small"
            clearable
            class="mr10 ipt"
            @input="filterGt0OrFixed2('profitValue')"
            v-model.trim="ruleForm.profitValue"
            placeholder="请输入0-10数字"
          ></el-input
          >折
        </div>
        <div>
          分销权益
          <el-input
            type="number"
            style="width:130px"
            size="small"
            clearable
            class="mr10 ipt"
            @input="filterGt0OrFixed2('shareProfitValue')"
            v-model.trim="ruleForm.shareProfitValue"
            placeholder="请输入分销权益"
          ></el-input
          >折
        </div>
      </el-form-item>
      <el-form-item label="启用状态">
        <el-switch
          v-model="ruleForm.enabledState"
          active-color="#2d8"
          inactive-color="#ddd"
          active-text="开启"
          inactive-text="关闭"
          active-value="yes"
          inactive-value="no"
        ></el-switch>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import { mapGetters } from "vuex";
export default {
  components: {
    myUpload
  },
  data() {
    const profitValue = function(rule, val, callback) {
      if (val) {
        if (!(val >= 0 && val <= 10)) {
          return callback(new Error("商品折扣请输入0-10数字"));
        }
      }
      callback();
    }.bind(this);
    const relIdLabel = function(rule, val, callback) {
      if (
        (this.ruleForm.relType === "membercard" &&
          !this.ruleForm.relIdCardValue) ||
        (this.ruleForm.relType === "memberlabel" &&
          !this.ruleForm.relIdLabelValue.length)
      ) {
        return callback(new Error("请选择规则"));
      }
      callback();
    }.bind(this);
    return {
      listHeaderImgUrl: "",
      show: false,
      ruleForm: {
        relType: "membercard",
        profitValue: "",
        relIdCardValue: "",
        relIdLabelValue: [],
        shareProfitValue: ""
      },
      rules: {
        groupAppellation: [
          { required: true, message: "请输入群组名称", trigger: "blur" }
        ],
        relType: [
          { required: true, message: "请选择关联信息", trigger: "blur" }
        ],
        relIdLabel: [
          { required: true, validator: relIdLabel, trigger: "change" }
        ],
        profitValue: [
          { required: true, message: "请填写商品折扣", trigger: "blur" },
          { required: true, validator: profitValue, trigger: "blur" }
        ]
      }
    };
  },
  computed: mapGetters(["vipCardTypeList", "alllabelSystemList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryCardTypeList();
    this.queryLabelName();
  },
  methods: {
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "");
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[
      //   prop
      // ].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    switchRelType(e) {
      if (e === "memberlabel") {
        this.ruleForm.relIdCardValue = "";
      } else {
        this.ruleForm.relIdLabelValue = [];
      }
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    queryCardTypeList() {
      this.$store.dispatch("queryVipCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    queryLabelName() {
      return this.$store.dispatch("queryALLLabelSystemList", {
        pageSize: 99999,
        pageNo: 1
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    deleteListHeader() {
      this.$refs.editorUpload.handleRemove();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          if (params.profitValue === "") {
            params.profitValue = "10";
          }
          if (params.shareProfitValue === "") {
            params.shareProfitValue = "10";
          }
          this.$store.dispatch("addGroup", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 750px;
  height: 360px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
